import React from "react";
import Highlight, { defaultProps } from "prism-react-renderer";
import { Box } from "./box";

const exampleCode = `
(function someDemo() {
  var test = "Hello World!";
  console.log(test);
})();

return () => <App />;
`;

export const Code = ({ code = exampleCode, language = "jsx" }) => {
  return (
    <Highlight {...defaultProps} code={code} language={language}>
      {({ className, style, tokens, getLineProps, getTokenProps }) => (
        <Box
          paddingLeft="l"
          paddingTop="l"
          paddingRight="l"
          paddingBottom="l"
          borderRadius="m"
          Component="pre"
          display="flex"
          flexDirection="column"
          flex={1}
          className={className}
          style={{
            ...style,
            overflow: "scroll",
            maxWidth: "100%",
          }}
        >
          {tokens.map((line, i) => (
            <Box
              Component="div"
              paddingTop="xs"
              paddingBottom="xs"
              {...getLineProps({ line, key: i })}
            >
              {line.map((token, key) => (
                <span {...getTokenProps({ token, key })} />
              ))}
            </Box>
          ))}
        </Box>
      )}
    </Highlight>
  );
};
